export default {"src":"/_next/static/media/Logo.1a6756ad.svg","height":59,"width":156,"blurWidth":0,"blurHeight":0};